import { makeContextModule } from '@cian/react-utils';

import { IApplicationContext } from 'shared/mf-my-home/types/applicationContext';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
